module.exports = __webpack_public_path__ + "img/ResidentOffice1.4458f64b.png";